// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'pause';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M6.188 2.813H5.063c-.622 0-1.125.503-1.125 1.124v10.126c0 .62.503 1.124 1.124 1.124h1.125c.622 0 1.125-.503 1.125-1.124V3.937c0-.62-.503-1.124-1.125-1.124zm6.75 0h-1.126c-.62 0-1.124.503-1.124 1.124v10.126c0 .62.503 1.124 1.124 1.124h1.126c.62 0 1.124-.503 1.124-1.124V3.937c0-.62-.503-1.124-1.124-1.124z'
  />
);

export const viewBox = '0 0 18 18';
